// extracted by mini-css-extract-plugin
export default {"bgCover":"Products_bgCover__L+Po4","coverText":"Products_coverText__clek7","link":"Products_link__PQ381","title":"Products_title__1E+Ep","list":"Products_list__yl+9j"};